import React from 'react';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import { CustomBreadcrumbs, CustomList } from 'candy-commons-components';
import {
    TextField,
    useTranslate,
    FunctionField,
    BooleanField,
} from 'react-admin';
import DynamoPagination from '../../components/DynamoPagination';
import CustomDatagrid from '../../components/organisms/customDatagrid';

const WalletCategoryList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.wallet-category.name'),
            url: '',
            icon: <AccountBalanceWalletIcon />,
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                exporter={false}
                sort={{ field: 'lastUpdate', order: 'DESC' }}
                perPage={25}
                {...props}
                pagination={<DynamoPagination resource="wallet-category" />}
                // No bulk delete — categories are disabled, not deleted
                bulkActionButtons={false}
            >
                <CustomDatagrid selectable rowClick="edit" choiceColumns>
                    <TextField source="widget" />
                    <TextField source="type" />
                    <TextField source="code" />
                    <TextField source="name" />
                    <TextField source="icon" />
                    <FunctionField
                        label="Color"
                        source="color"
                        render={(record) =>
                            record.color ? (
                                <span
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                    }}
                                >
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            width: 18,
                                            height: 18,
                                            borderRadius: '50%',
                                            background: record.color,
                                            border: '1px solid #ccc',
                                        }}
                                    />
                                    {record.color}
                                </span>
                            ) : (
                                '—'
                            )
                        }
                    />
                    <BooleanField source="active" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};

export default WalletCategoryList;
